// userSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCurrentUser } from "./services/authService";

export const fetchCurrentUser = createAsyncThunk(
  "user/fetchCurrentUser",
  async (_, thunkAPI) => {
    try {
      const u = await getCurrentUser();
      return u; 
    } catch (err) {
      return null; // means not logged in or 401
    }
  }
);

/* short English comments only */
const userSlice = createSlice({
  name: "user",
  initialState: {
    user: undefined, 
    status: "idle" 
  },
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      if (action.payload) {
        state.status = "success";
      } else {
        state.status = "success";
      }
    },
    clearUser(state) {
      state.user = null;
      state.status = "success";
    },
    // Update for multi-organization support
    updateCurrentOrganization(state, action) {
      if (state.user) {
        state.user.currentOrganization = action.payload.organization;
        state.user.lastOrganization = action.payload.organization;
      }
    },
    updateOrganizationLogo(state, action) {
      if (state.user && state.user.currentOrganization) {
        state.user.currentOrganization.logo = action.payload;
      }
    },
    updateOrganizationTimezone(state, action) {
      if (state.user && state.user.currentOrganization) {
        state.user.currentOrganization.timeZone = action.payload;
      }
    },
    updateOrganizationSettings(state, action) {
      if (state.user && state.user.currentOrganization) {
        console.log('🔄 Redux: updateOrganizationSettings called with:', action.payload);
        console.log('🔄 Redux: Current organization before update:', state.user.currentOrganization);
        
        // Update multiple organization settings at once
        const settings = action.payload;
        Object.keys(settings).forEach(key => {
          if (settings[key] !== undefined) {
            console.log(`🔄 Redux: Setting ${key} from "${state.user.currentOrganization[key]}" to "${settings[key]}"`);
            state.user.currentOrganization[key] = settings[key];
          }
        });
        
        console.log('🔄 Redux: Current organization after update:', state.user.currentOrganization);
        console.log('🔄 Redux: Time settings specifically:', {
          defaultStartTime: state.user.currentOrganization.defaultStartTime,
          defaultEndTime: state.user.currentOrganization.defaultEndTime
        });
      } else {
        console.log('❌ Redux: Cannot update organization settings - no user or organization');
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCurrentUser.pending, (state) => {
        state.status = "loading";
        state.user = undefined;
      })
      .addCase(fetchCurrentUser.fulfilled, (state, action) => {
        state.user = action.payload; // might be object or null
        state.status = "success";
      })
      .addCase(fetchCurrentUser.rejected, (state) => {
        state.user = null;
        state.status = "success";
      });
  }
});

export const { setUser, clearUser, updateCurrentOrganization, updateOrganizationLogo, updateOrganizationTimezone, updateOrganizationSettings } = userSlice.actions;
export default userSlice.reducer;
